import axios from '@/axios' 
import settingEncryption from "@/utils/addEncrypto"
  
export default async function setAuthData() { 
  const response = await axios.get(`/auth/me`)

  const userData = {
    ...response.data,
    status: response.status
  }

  const encrypted = settingEncryption(userData, "@qG56W5w04YI");

  localStorage.setItem('userData', encrypted); 
}